// import React from "react";
// import {
//   BarChart,
//   Bar,
//   XAxis,
//   YAxis,
//   CartesianGrid,
//   Tooltip,
//   Legend,
//   ResponsiveContainer,
// } from "recharts";
// import CapitalizeFirstLetter from "../../../shared/utils/CapitalizeFirstLetter";

// const WorkAllocation = ({ CampaignDetails }) => {
//   console.log(CampaignDetails);
//   return (
//     <div className="bg-white shadow-md rounded-lg p-4">
//       <div className="flex items-center justify-between">
//         <h2 className="text-lg font-semibold text-gray-800">Work Progress</h2>
//         <div className="flex items-center space-x-4">
//           <div className="flex items-center space-x-1">
//             <span className="w-4 h-4 bg-blue-100 rounded-sm"></span>
//             <span className="text-gray-600 text-sm">Planned</span>
//           </div>
//           <div className="flex items-center space-x-1">
//             <span className="w-4 h-4 bg-blue-500 rounded-sm"></span>
//             <span className="text-gray-600 text-sm">Completed</span>
//           </div>
//         </div>
//       </div>
//       <p className="mt-2">
//         <span className="text-green-500 text-3xl ">
//           {Math.round(CampaignDetails.totalWorkPercentage)}
//           {"% "}
//         </span>
//         Completed
//       </p>
//       <div className="mt-4">
//         <div className="w-full h-96">
//           <ResponsiveContainer width="100%" height="100%">
//             <BarChart
//               data={CampaignDetails?.barGraphData}
//               margin={{
//                 top: 10,
//                 right: 20,
//                 left: 10,
//                 bottom: 5,
//               }}
//             >
//               <CartesianGrid horizontal={true} vertical={false} />
//               <XAxis dataKey="category" tick={{ fill: "#4B5563" }} />
//               <YAxis tick={{ fill: "#4B5563" }} />
//               <Tooltip
//                 contentStyle={{
//                   backgroundColor: "white",
//                   border: "1px solid #D1D5DB",
//                 }}
//               />
//               {/* <Legend verticalAlign="top" height={36} /> */}
//               <Bar
//                 dataKey="totalJobs"
//                 fill="#D6E3FF"
//                 radius={[5, 5, 0, 0]}
//                 name="Total Jobs"
//               />
//               <Bar
//                 dataKey="completedJobs"
//                 fill="#488BFF"
//                 radius={[5, 5, 0, 0]}
//                 name="Completed Jobs"
//               />
//             </BarChart>
//           </ResponsiveContainer>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default WorkAllocation;

///////////// new code //////////////////
import { ToggleButton, ToggleButtonGroup } from "@mui/material";
import React, { useState, useMemo, useEffect } from "react";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
} from "recharts";

const WorkAllocation = ({ CampaignDetails, productType }) => {
  const barGraphData = CampaignDetails?.barGraphData || [];
  const [totalPercentage, setTotalPercentage] = React.useState(0);
  const [totalPercentageStoreWise, setTotalPercentageStoreWise] =
    React.useState(0);
  const [view, setView] = useState("storeView");
  const handleToggleChange = (event, newView) => {
    if (newView !== null) {
      setView(newView);
    }
  };
  const effectiveProductType = productType.length === 0 ? ["All"] : productType;

  // Prepare chart data
  const chartData = useMemo(() => {
    let dataMap = {};
    let totalNumberOfJobs = 0;
    let totalNumberOfCompletedJobs = 0;

    const filteredProducts = effectiveProductType.includes("All")
      ? barGraphData
      : barGraphData.filter((p) =>
        effectiveProductType.includes(p.productType),
      );

    filteredProducts?.forEach((product) => {
      product?.servicesCount?.forEach((service) => {
        if (!dataMap[service.category]) {
          dataMap[service.category] = {
            category: service.category,
            totalJobs: 0,
            completedJobs: 0,
          };
        }
        dataMap[service.category].totalJobs += service.totalJobs;
        dataMap[service.category].completedJobs += service.completedJobs;

        totalNumberOfJobs += service.totalJobs;
        totalNumberOfCompletedJobs += service.completedJobs;
      });
    });

    return {
      chart: Object.values(dataMap),
      totalJobs: totalNumberOfJobs,
      completedJobs: totalNumberOfCompletedJobs,
    };
  }, [effectiveProductType, barGraphData]);
  const transformStoreWiseDataForChart = (storeWiseBarGraphData) => {
    // Safety check - if data is undefined or not an array, return empty result
    if (!storeWiseBarGraphData || !Array.isArray(storeWiseBarGraphData)) {
      return { chart: [], totalNumberOfCompletedStores: 0, totalNumberOfStores: 0 };
    }

    let totalNumberOfStores = 0;
    let totalNumberOfCompletedStores = 0;

    const categoryTotals = storeWiseBarGraphData.reduce((acc, store) => {
      if (!store || !store.servicesCount) return acc;
      store.servicesCount.forEach(({ category, totalJobs, completedJobs }) => {
        if (!acc[category]) {
          acc[category] = { totalStores: 0, completedStores: 0 };
        }

        // Count the store itself, not its individual jobs
        if (totalJobs > 0) {
          acc[category].totalStores += 1;
        }
        // Store is complete only when every job in this category is done
        if (totalJobs > 0 && completedJobs === totalJobs) {
          acc[category].completedStores += 1;
        }
      });
      return acc;
    }, {});

    const chart = Object.entries(categoryTotals).map(([category, counts]) => ({
      category,
      ...counts,
    }));
    for (let service of chart) {
      totalNumberOfStores += service.totalStores;
      totalNumberOfCompletedStores += service.completedStores;
    }

    return { chart, totalNumberOfCompletedStores, totalNumberOfStores };
  };
  const chartDataStoreWise = useMemo(
    () =>
      transformStoreWiseDataForChart(CampaignDetails?.storeWiseBarGraphData || []),
    [CampaignDetails?.storeWiseBarGraphData],
  );
  useEffect(() => {
    if (chartDataStoreWise.totalNumberOfStores > 0) {
      setTotalPercentageStoreWise(
        (chartDataStoreWise.totalNumberOfCompletedStores /
          chartDataStoreWise.totalNumberOfStores) *
        100,
      );
    } else {
      setTotalPercentageStoreWise(0);
    }
  }, [chartDataStoreWise]);
  // ✅ Update totalPercentage only when chartData changes
  useEffect(() => {
    if (chartData.totalJobs > 0) {
      setTotalPercentage((chartData.completedJobs / chartData.totalJobs) * 100);
    } else {
      setTotalPercentage(0);
    }
  }, [chartData]);
  return (
    <div className="bg-white shadow-md rounded-lg p-4">
      <div className="flex items-center justify-between">
        <h2 className="text-lg font-semibold text-gray-800">Work Progress</h2>
        <ToggleButtonGroup
          value={view}
          exclusive
          onChange={handleToggleChange}
          size="small"
        >
          <ToggleButton value="storeView">Store View</ToggleButton>
          <ToggleButton value="jobView">Job View</ToggleButton>
        </ToggleButtonGroup>
      </div>

      <p className="mt-2">
        <span className="text-green-500 text-3xl ">
          {view === "jobView"
            ? `${Math.round(totalPercentage)}%`
            : `${Math.round(totalPercentageStoreWise)}%`}
        </span>
        {`Completed`}
      </p>

      <div className="mt-4">
        {view === "jobView" ? (
          <div className="w-full h-96">
            <ResponsiveContainer width="100%" height="95%">
              <BarChart
                data={chartData?.chart}
                margin={{
                  top: 10,
                  right: 20,
                  left: 10,
                  bottom: 5,
                }}
                barGap={20}
                barCategoryGap="25%"
              >
                <CartesianGrid horizontal={true} vertical={false} />
                <XAxis dataKey="category" tick={<CustomXAxisTick />} />
                <YAxis tick={{ fill: "#4B5563" }} />
                <Tooltip content={<CustomTooltip />} />
                <Bar
                  dataKey="totalJobs"
                  fill="#292D30"
                  name="Total Jobs"
                  radius={[9, 9, 9, 9]}
                  barSize={43}
                />
                <Bar
                  dataKey="completedJobs"
                  fill="#34B3F1"
                  name="Completed Jobs"
                  radius={[9, 9, 9, 9]}
                  barSize={43}
                />
              </BarChart>
            </ResponsiveContainer>
            <div className="flex items-center space-x-16 mt-2 justify-center">
              <div className="flex items-center space-x-1">
                <span className="w-4 h-4 bg-black rounded-sm"></span>
                <span className="text-gray-600 text-sm font-normal">
                  Total Jobs
                </span>
              </div>
              <div className="flex items-center space-x-1">
                <span className="w-4 h-4 bg-[#34B3F1] rounded-sm"></span>
                <span className="text-gray-600 text-sm font-normal">
                  Completed Jobs
                </span>
              </div>
            </div>
          </div>
        ) : (
          <div className="w-full h-96">
            <ResponsiveContainer width="100%" height="95%">
              <BarChart
                data={chartDataStoreWise?.chart || []}
                margin={{
                  top: 10,
                  right: 20,
                  left: 10,
                  bottom: 5,
                }}
                barGap={20}
                barCategoryGap="25%"
              >
                <CartesianGrid horizontal={true} vertical={false} />
                <XAxis dataKey="category" tick={<CustomXAxisTick />} />
                <YAxis tick={{ fill: "#4B5563" }} />
                <Tooltip content={<CustomTooltip />} />
                <Bar
                  dataKey="totalStores"
                  fill="#292D30"
                  name="Total Stores"
                  radius={[9, 9, 9, 9]}
                  barSize={43}
                />
                <Bar
                  dataKey="completedStores"
                  fill="#34B3F1"
                  name="Completed Stores"
                  radius={[9, 9, 9, 9]}
                  barSize={43}
                />
              </BarChart>
            </ResponsiveContainer>
            <div className="flex items-center space-x-16 mt-2 justify-center">
              <div className="flex items-center space-x-1">
                <span className="w-4 h-4 bg-black rounded-sm"></span>
                <span className="text-gray-600 text-sm font-normal">
                  Total Stores
                </span>
              </div>
              <div className="flex items-center space-x-1">
                <span className="w-4 h-4 bg-[#34B3F1] rounded-sm"></span>
                <span className="text-gray-600 text-sm font-normal">
                  Completed Stores
                </span>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default WorkAllocation;

const formatCategory = (value) => {
  return value === "Manufacturing" ? "Supply" : value;
};

const CustomTooltip = ({ active, payload, label }) => {
  if (active && payload && payload.length) {
    return (
      <div className="bg-black p-3 border border-gray-200 shadow-md rounded">
        <p className="font-medium text-white">{formatCategory(label)}</p>
        {payload.map((entry, index) => (
          <p key={index} className="text-sm text-white">
            {entry.name}: {entry.value}
          </p>
        ))}
      </div>
    );
  }
  return null;
};

// Custom tick component to show category names only once
const CustomXAxisTick = ({ x, y, payload }) => {
  return (
    <g transform={`translate(${x},${y})`}>
      <text
        x={0}
        y={0}
        dy={16}
        textAnchor="middle"
        fill="#8D9092"
        fontSize="16px"
        fontWeight="400"
      >
        {formatCategory(payload.value)}
      </text>
    </g>
  );
};
